module.exports = __webpack_public_path__ + "static/img/light.e728134.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fortune-wheel/light.png
// module id = ifnv
// module chunks = 216